import React, { useContext, useEffect, useState } from 'react';
import {
    Box, Typography, TextField, Button, Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow, Paper,
    IconButton, Avatar, Select, MenuItem, FormControl, InputLabel,
    CircularProgress, Tooltip, Pagination,
    Divider
} from '@mui/material';
import { Edit, Delete, Add } from '@mui/icons-material';
import axios from 'axios';
import apiUrl from '../../Config';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Context from '../../context/Context';
import DeleteConfirm from '../../Common/DeleteConfirm';

const DisplayVehicleModel = () => {
    const { isConfirmDeleteModelOpen, setIsConfirmDeleteModelOpen, itemIdToDelete,
        confirmDelete } = useContext(Context);
    const [vehicleModels, setVehicleModels] = useState([]);
    const [vehicleBrands, setVehicleBrands] = useState([]);
    const [brandId, setBrandId] = useState('');
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(5);
    const [totalPages, setTotalPages] = useState(1);
    const [error, setError] = useState('')

    const navigate = useNavigate();

    const fetchModels = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${apiUrl}/brandmodel/getallbrands`, {
                params: {
                    brandId: brandId || undefined,
                    search,
                    pageNumber: page,
                    pageSize: limit
                }
            });
            if (res?.data?.status === true) {

                setVehicleModels(res.data.models || []);
                setTotalPages(res.data.totalPages || 1);
            }
        } catch (err) {
            setError("Error fetching models:", err);
        } finally {
            setLoading(false);
        }
    };

    const fetchBrands = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`${apiUrl}/vehiclebrand/getallbrands`);
            if (res?.data?.status === true) {

                setVehicleBrands(res.data.brands || []);
            }
        } catch (err) {
            setError("Error fetching brands:", err);
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchBrands();
    }, []);

    useEffect(() => {
        fetchModels();
    }, [page, limit, brandId]);

    const handleSearch = () => {
        setPage(1);
        fetchModels();
    };

    const handleDelete = async () => {
        setLoading(true)
        setIsConfirmDeleteModelOpen(false)
        try {
            const response = await axios.delete(`${apiUrl}/brandmodel/deletebrandmodel/${itemIdToDelete}`)
            if (response.data.status == true) {
                fetchModels()
                toast.success(response.data.message)
            }
        } catch (error) {
            setError(error, "error")
        }
        finally {
            setLoading(false)
        }
    };

    const handleEdit = (model) => {
        navigate('/create-edit-vehicle-model', { state: model });
    };

    const handleAddNew = () => {
        navigate('/create-edit-vehicle-model');
    };

    return (
        <>
            <Box sx={{ p: 3 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" mb={2}>
                    <Typography variant="h3" >Vehicle Models</Typography>
                    <Button variant="contained" startIcon={<Add />} onClick={handleAddNew}>
                        Add Model
                    </Button>
                </Box>
                <Divider sx={{mb:2}}/>

                {/* Search & Filter */}
                <Box display="flex" justifyContent={'space-between'} flexWrap="wrap" gap={2} mb={2} alignItems="center">
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            label="Search by Name"
                            size="small"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                         <FormControl size="small" sx={{ minWidth: 160 }}>
                            <InputLabel>Filter by Brand</InputLabel>
                            <Select
                                value={brandId}
                                label="Filter by Brand"
                                onChange={(e) => {
                                    setBrandId(e.target.value);
                                    setPage(1);
                                }}
                            >
                                <MenuItem value="">All Brands</MenuItem>
                                {vehicleBrands.map((brand) => (
                                    <MenuItem key={brand.id} value={brand.id}>
                                        {brand.brandName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Button variant="contained" onClick={handleSearch}>Search</Button>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                       

                        <FormControl size="small">
                            <InputLabel>Rows</InputLabel>
                            <Select
                                value={limit}
                                label="Rows"
                                onChange={(e) => {
                                    setLimit(Number(e.target.value));
                                    setPage(1);
                                }}
                            >
                                {[5, 10, 20].map(n => (
                                    <MenuItem key={n} value={n}>{n}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>


                </Box>

                {/* Table */}
                {loading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height={150}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {vehicleModels.length === 0 ? (
                            <Typography>No vehicle models found.</Typography>
                        ) : (
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Logo</TableCell>
                                            <TableCell>Model Name</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell align="right">Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {vehicleModels.map((model) => (
                                            <TableRow key={model.id}>
                                                <TableCell>
                                                    <Avatar src={model.modelLogo} variant="square" alt={model.modelName} />
                                                </TableCell>
                                                <TableCell>{model.modelName}</TableCell>
                                                <TableCell>{model.isActive ? 'Active' : 'Inactive'}</TableCell>
                                                <TableCell align="right">
                                                    <Tooltip title="Edit">
                                                        <IconButton onClick={() => handleEdit(model)} color="">
                                                            <Edit />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <IconButton onClick={() => confirmDelete(model.id)} color="error">
                                                            <Delete />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                        {error &&
                            <Typography variant='body2' color='error'>{error}</Typography>}

                        {/* Pagination */}
                        <Box mt={2} display="flex" justifyContent="center">
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={(e, value) => setPage(value)}
                                color="primary"
                                showFirstButton
                                showLastButton
                                siblingCount={0}
                                boundaryCount={1}
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        height: 32,
                                        minWidth: 32,
                                        fontSize: '0.875rem'
                                    }
                                }}
                            />
                        </Box>
                    </>
                )}

            </Box>
            <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />
        </>
    );
};

export default DisplayVehicleModel;
